/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarCupomCategoriaDto,
  CriarCupomCategoriaDto,
  CupomCategoriaResponse,
  DefinirAtivoCategoriaDto,
  ErroResponse,
  ListaDeCategoriasResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCupomCategoriasControllerListarUrl = () => {




  return `/v1/admin/cupom-categorias`
}

/**
 * @summary Lista as categorias. São poucas — sem paginação.
 */
export const cupomCategoriasControllerListar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeCategoriasResponse> => {

  return httpClient<ListaDeCategoriasResponse>(getCupomCategoriasControllerListarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCupomCategoriasControllerListarQueryKey = () => {
    return [
    `/v1/admin/cupom-categorias`
    ] as const;
    }


export const getCupomCategoriasControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCupomCategoriasControllerListarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>> = ({ signal }) => cupomCategoriasControllerListar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CupomCategoriasControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>>
export type CupomCategoriasControllerListarQueryError = ErroResponse


export function useCupomCategoriasControllerListar<TData = Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cupomCategoriasControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cupomCategoriasControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCupomCategoriasControllerListar<TData = Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cupomCategoriasControllerListar>>,
          TError,
          Awaited<ReturnType<typeof cupomCategoriasControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCupomCategoriasControllerListar<TData = Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as categorias. São poucas — sem paginação.
 */

export function useCupomCategoriasControllerListar<TData = Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof cupomCategoriasControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCupomCategoriasControllerListarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCupomCategoriasControllerCriarUrl = () => {




  return `/v1/admin/cupom-categorias`
}

/**
 * @summary Cria uma categoria. Sem `ordem`, entra no fim.
 */
export const cupomCategoriasControllerCriar = async (criarCupomCategoriaDto: CriarCupomCategoriaDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomCategoriaResponse> => {

  return httpClient<CupomCategoriaResponse>(getCupomCategoriasControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarCupomCategoriaDto)
  }
);}





export const getCupomCategoriasControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerCriar>>, TError,{data: CriarCupomCategoriaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerCriar>>, TError,{data: CriarCupomCategoriaDto}, TContext> => {

const mutationKey = ['cupomCategoriasControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cupomCategoriasControllerCriar>>, {data: CriarCupomCategoriaDto}> = (props) => {
          const {data} = props ?? {};

          return  cupomCategoriasControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CupomCategoriasControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof cupomCategoriasControllerCriar>>>
    export type CupomCategoriasControllerCriarMutationBody = CriarCupomCategoriaDto
    export type CupomCategoriasControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria uma categoria. Sem `ordem`, entra no fim.
 */
export const useCupomCategoriasControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerCriar>>, TError,{data: CriarCupomCategoriaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cupomCategoriasControllerCriar>>,
        TError,
        {data: CriarCupomCategoriaDto},
        TContext
      > => {
      return useMutation(getCupomCategoriasControllerCriarMutationOptions(options), queryClient);
    }
    export const getCupomCategoriasControllerAtualizarUrl = (categoriaId: string,) => {




  return `/v1/admin/cupom-categorias/${categoriaId}`
}

/**
 * @summary Renomeia ou reordena a categoria
 */
export const cupomCategoriasControllerAtualizar = async (categoriaId: string,
    atualizarCupomCategoriaDto: AtualizarCupomCategoriaDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomCategoriaResponse> => {

  return httpClient<CupomCategoriaResponse>(getCupomCategoriasControllerAtualizarUrl(categoriaId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarCupomCategoriaDto)
  }
);}





export const getCupomCategoriasControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerAtualizar>>, TError,{categoriaId: string;data: AtualizarCupomCategoriaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerAtualizar>>, TError,{categoriaId: string;data: AtualizarCupomCategoriaDto}, TContext> => {

const mutationKey = ['cupomCategoriasControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cupomCategoriasControllerAtualizar>>, {categoriaId: string;data: AtualizarCupomCategoriaDto}> = (props) => {
          const {categoriaId,data} = props ?? {};

          return  cupomCategoriasControllerAtualizar(categoriaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CupomCategoriasControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof cupomCategoriasControllerAtualizar>>>
    export type CupomCategoriasControllerAtualizarMutationBody = AtualizarCupomCategoriaDto
    export type CupomCategoriasControllerAtualizarMutationError = unknown

    /**
 * @summary Renomeia ou reordena a categoria
 */
export const useCupomCategoriasControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerAtualizar>>, TError,{categoriaId: string;data: AtualizarCupomCategoriaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cupomCategoriasControllerAtualizar>>,
        TError,
        {categoriaId: string;data: AtualizarCupomCategoriaDto},
        TContext
      > => {
      return useMutation(getCupomCategoriasControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCupomCategoriasControllerDefinirAtivoUrl = (categoriaId: string,) => {




  return `/v1/admin/cupom-categorias/${categoriaId}/ativo`
}

/**
 * @summary Ativa ou desativa. Não existe excluir: o delete soltaria os cupons em silêncio.
 */
export const cupomCategoriasControllerDefinirAtivo = async (categoriaId: string,
    definirAtivoCategoriaDto: DefinirAtivoCategoriaDto, options?: Parameters<typeof httpClient>[1]): Promise<CupomCategoriaResponse> => {

  return httpClient<CupomCategoriaResponse>(getCupomCategoriasControllerDefinirAtivoUrl(categoriaId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoCategoriaDto)
  }
);}





export const getCupomCategoriasControllerDefinirAtivoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerDefinirAtivo>>, TError,{categoriaId: string;data: DefinirAtivoCategoriaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerDefinirAtivo>>, TError,{categoriaId: string;data: DefinirAtivoCategoriaDto}, TContext> => {

const mutationKey = ['cupomCategoriasControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cupomCategoriasControllerDefinirAtivo>>, {categoriaId: string;data: DefinirAtivoCategoriaDto}> = (props) => {
          const {categoriaId,data} = props ?? {};

          return  cupomCategoriasControllerDefinirAtivo(categoriaId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CupomCategoriasControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof cupomCategoriasControllerDefinirAtivo>>>
    export type CupomCategoriasControllerDefinirAtivoMutationBody = DefinirAtivoCategoriaDto
    export type CupomCategoriasControllerDefinirAtivoMutationError = unknown

    /**
 * @summary Ativa ou desativa. Não existe excluir: o delete soltaria os cupons em silêncio.
 */
export const useCupomCategoriasControllerDefinirAtivo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cupomCategoriasControllerDefinirAtivo>>, TError,{categoriaId: string;data: DefinirAtivoCategoriaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cupomCategoriasControllerDefinirAtivo>>,
        TError,
        {categoriaId: string;data: DefinirAtivoCategoriaDto},
        TContext
      > => {
      return useMutation(getCupomCategoriasControllerDefinirAtivoMutationOptions(options), queryClient);
    }
